const readAuthReturnTo = (callbackSearch: string): string | null => {
	const state = new URLSearchParams(callbackSearch).get("state");
	if (!state) return null;
	try {
		const returnTo: unknown = JSON.parse(state).returnTo;
		if (typeof returnTo !== "string" || !returnTo.startsWith("/") || returnTo.startsWith("//")) return null;
		return returnTo;
	} catch {
		return null;
	}
};

export default readAuthReturnTo;
